import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import React, { useEffect } from 'react'

interface Props {
    selectedValue?: string;
    onValueChange?: (value: string | undefined) => void;
}

const SelectRolePosition = ({ selectedValue, onValueChange }: Props) => {
    const [value, setValue] = React.useState<string | undefined>(selectedValue)

    const handleChange = (v: string) => {
        if(v === value) {
            setValue(undefined)
            onValueChange?.(undefined)
        } else {
            setValue(v)
            onValueChange?.(v)
        }
    }

    useEffect(()=>{
        if(!selectedValue) return;
        if(value !== selectedValue) {
            setValue(selectedValue)
        }
    }, [selectedValue])

    return (
        <Select value={value} onValueChange={handleChange}>
            <SelectTrigger><SelectValue placeholder='Selecteer'/></SelectTrigger>
            <SelectContent>
                <SelectItem value="1a">1A</SelectItem>
                <SelectItem value="1b">1B</SelectItem>
                <SelectItem value="2a">2A</SelectItem>
                <SelectItem value="2b">2B</SelectItem>
                <SelectItem value="3a">3A</SelectItem>
                <SelectItem value="3b">3B</SelectItem>
                <SelectItem value="4a">4A</SelectItem>
                <SelectItem value="4b">4B</SelectItem>
                <SelectItem value="5a">5A</SelectItem>
                <SelectItem value="5b">5B</SelectItem>
                <SelectItem value="6a">6A</SelectItem>
                <SelectItem value="6b">6B</SelectItem>
                <SelectItem value="7a">7A</SelectItem>
                <SelectItem value="7b">7B</SelectItem>
                <SelectItem value="7c">7C</SelectItem>
                <SelectItem value="8a">8A</SelectItem>
                <SelectItem value="8b">8B</SelectItem>
                <SelectItem value="9a">9A</SelectItem>
                <SelectItem value="9b">9B</SelectItem>
                <SelectItem value="9c">9C</SelectItem>
                <SelectItem value="10a">10A</SelectItem>
                <SelectItem value="10b">10B</SelectItem>
                <SelectItem value="10c">10C</SelectItem>
                <SelectItem value="11a">11A</SelectItem>
                <SelectItem value="11b">11B</SelectItem>
                <SelectItem value="11c">11C</SelectItem>
            </SelectContent>
        </Select>
    )
}

export default SelectRolePosition